export default __webpack_public_path__ + "static/media/polygon-matic-logo.2f48ca1f.svg";